import { createApiSlice } from "@common";
import { CRUD_ACTIVITY_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addActivityStatus",
    method: "post",
    url: CRUD_ACTIVITY_STATUS,
    stateKey: "message",
  },
  {
    name: "getActivityStatus",
    method: "get",
    url: CRUD_ACTIVITY_STATUS,
    stateKey: "data",
  },
  {
    name: "updateActivityStatus",
    method: "put",
    url: CRUD_ACTIVITY_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteActivityStatus",
    method: "delete",
    url: CRUD_ACTIVITY_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "activityStatus",
  apiConfig,
  customReducers);
const activityStatusSlice = slice;

export default activityStatusSlice.reducer;

export const {
  addActivityStatus,
  getActivityStatus,
  updateActivityStatus,
  deleteActivityStatus,
} = thunks;

export const { rowSelect } = actions;
